import React, {useLayoutEffect, useState} from "react";
import {authActions} from "../store";
import {useDispatch} from "react-redux";
import {useTranslation} from "react-i18next";
import {Input, message} from "antd";
import {fetchWrapper} from "../helpers";
import {LanguageHeader} from "../components/LanguageHeader";
import {jwtDecode} from "jwt-decode";


const VerifyEmail = () => {
	const [antiSpamInterval, setAntiSpamInterval] = useState({
		interval: undefined,
		seconds: 0,
		isLoading: true,
	});
	const {t} = useTranslation();
	const dispatch = useDispatch();
	const [code, setCode] = useState('');

	const handleChangeCode = (code) => setCode(code);

	const handleVerifyEmail = () => {

		fetchWrapper.post(
		`${process.env.REACT_APP_API_URL}/auth/verify-email`,
	{token: code}
		)
				.then((res)=>{

					message.success(t("welcome.verifyEmailSuccess"));
					localStorage.removeItem('resendCodeDate');
					setTimeout(()=>{
						window.location.reload();
					},1000);
				})
				.catch((err)=>{
					message.error(t("welcome.verifyEmailError"));

				});

	};

	const handleIntervalGuard = (seconds = 60) => {
		let timer = seconds;
		const interval = setInterval(() => {
			if (timer <= 0) {
				setAntiSpamInterval({
					interval: undefined,
					seconds: 0,
					isLoading: false,
				});
				clearInterval(interval);
			} else {
				setAntiSpamInterval({
					interval: interval,
					seconds: timer,
				});
			}
			timer--;
		}, 1000);
	};

	const handleResendCode = async () => {
		setAntiSpamInterval(prevState => ({...prevState, isLoading: true}));
		fetchWrapper.post(`${process.env.REACT_APP_API_URL}/auth/verify-email-request`, {
			username: jwtDecode(JSON?.parse(localStorage.getItem('user')).accessToken)?.username || undefined,
		})
				.then((res)=>{
					message.success(t("welcome.resendVerifyCodeSuccess"));
					handleIntervalGuard(60);
				})
				.catch((err)=>{
					message.error(`${t("functions.error")}! ${t("functions.wrong")}`);
					setAntiSpamInterval(prevState => ({...prevState, isLoading: false}));
					console.log(err)
				});
	};

	useLayoutEffect(() => {
		const resendCodeDate = localStorage.getItem('resendCodeDate');
		const minutesDiff = (new Date().getTime() - new Date(resendCodeDate).getTime()) / 1000 / 60;

		if (minutesDiff > 30){
			fetchWrapper.post(`${process.env.REACT_APP_API_URL}/auth/verify-email-request`, {
				username: jwtDecode(JSON?.parse(localStorage.getItem('user')).accessToken)?.username || undefined,
			}).then((res)=>{
				if (res){
					localStorage.setItem('resendCodeDate', new Date().toISOString());
					handleIntervalGuard(25);
				}
			}).catch((err)=>{
				console.log(err);
				setAntiSpamInterval(prevState => ({...prevState, isLoading: false}));
			});
		} else {
			setAntiSpamInterval(prevState => ({...prevState, isLoading: false}));
		}
	}, []);

	return (
			<div className="signup-wrapper">
						<LanguageHeader/>

				<div className='mt-16 mb-5 flex flex-col gap-5'>
					<h4 className='text-center font-semibold text-xl'>
						{t("welcome.verifyEmailTitle")}
					</h4>
					<p className='text-center'>
						{t("welcome.verifyEmailText")}
					</p>

					<div className='max-w-60 mx-auto'>
						<Input.OTP
								size='large'
								length={4}
								value={code}
								formatter={(str) => str.toUpperCase()}
								onChange={handleChangeCode}
						/>
					</div>

					{!!antiSpamInterval.seconds ? (
							<div className='flex items-center gap-1'>
								<p className='text-sm max-w-52 mx-auto text-center text-gray-500 font-semibold'>
									Запросить новый код можно будет через {antiSpamInterval.seconds}
								</p>
							</div>
					) : (
							<button
								disabled={!!antiSpamInterval.seconds || !!antiSpamInterval.isLoading}
								className='text-sm font-semibold hover:underline text-violet-600 hover:text-violet-700 disabled:text-gray-800 disabled:opacity-50 disabled:cursor-not-allowed'
								onClick={handleResendCode}
							>
								{t("welcome.resendVerifyCode")}
							</button>
						)}
				</div>

				<button
						disabled={!code}
						className="logout-button disabled:opacity-50 disabled:cursor-not-allowed"
						onClick={handleVerifyEmail}
				>
					{t("assistant.confirm")}
				</button>

				<button
						id="logout-mobile"
						className="logout-button !mt-16"
						onClick={() => dispatch(authActions.logout())}
				>
					{t("home.logout")}
				</button>
			</div>
	);
};

export default VerifyEmail;